export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/service-provider/notifications', 'service-provider.notifications')

    .within('service-provider')

    .segment('notifications', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.notifications'
      }],
      template: '<service-provider-notifications-list-page></service-provider-notifications-list-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-notifications-list.module" */ "./list/service-provider-notifications-list.module");
      }
    })
}
